import { render } from "./InviteCompany.vue?vue&type=template&id=57c25490&scoped=true"
import script from "./InviteCompany.vue?vue&type=script&lang=js"
export * from "./InviteCompany.vue?vue&type=script&lang=js"

import "./InviteCompany.vue?vue&type=style&index=0&id=57c25490&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c25490"]])

export default __exports__